import { PerformanceUtil } from './PerformanceUtil';

/* tslint:disable:no-internal-module radix */
export module UA {

  // UserAgent
  const uaString: string = window.navigator.userAgent.toLowerCase();
  const plathome: string = window.navigator.platform.toLowerCase();

  // 32bit 判定
  function win32(): boolean {
    // 32bit判定
    let w32: boolean;
    if (plathome === 'win32') {
      if (uaString.indexOf('win64') >= 0) {
        w32 = false;
      } else if (uaString.indexOf('wow64') >= 0) {
        w32 = false;
      } else {
        w32 = true;
      }
    } else {
      w32 = false;
    }

    return w32;
  }

  // ブラウザを判定
  function checkBrowser(): string {
    if (uaString.indexOf('msie') !== -1 || uaString.indexOf('trident') !== -1) {
      return 'Internet Explorer';
    } if (uaString.indexOf('edge') !== -1) {
      return 'Edge';
    } if (uaString.indexOf('chrome') !== -1) {
      return 'Chrome';
    } if (uaString.indexOf('safari') !== -1) {
      return 'Safari';
    } if (uaString.indexOf('firefox') !== -1) {
      return 'Firefox';
    } if (uaString.indexOf('opera') !== -1) {
      return 'Opera';
    }
    return 'Unknown';
  }

  export const ua: { Tablet: boolean, Mobile: boolean, Browser: string, IE: boolean, Win32: boolean, GPU: string, WebGL_version: string, GLSL_version: string, MaxTextureSize: number } = {
    Tablet: (uaString.indexOf('windows') !== -1 && uaString.indexOf('touch') !== -1)
      || (uaString.indexOf('ipad') > 0 || (uaString.indexOf('macintosh') > -1 && 'ontouchend' in document))
      || (uaString.indexOf('android') !== -1 && uaString.indexOf('mobile') === -1)
      || (uaString.indexOf('firefox') !== -1 && uaString.indexOf('tablet') !== -1)
      || uaString.indexOf('kindle') !== -1
      || uaString.indexOf('silk') !== -1
      || uaString.indexOf('playbook') !== -1,
    Mobile: (uaString.indexOf('windows') !== -1 && uaString.indexOf('phone') !== -1)
      || uaString.indexOf('iphone') !== -1
      || uaString.indexOf('ipod') !== -1
      || (uaString.indexOf('android') !== -1 && uaString.indexOf('mobile') !== -1)
      || (uaString.indexOf('firefox') !== -1 && uaString.indexOf('mobile') !== -1)
      || uaString.indexOf('blackberry') !== -1,
    Browser: checkBrowser(),
    IE: uaString.indexOf('msie') >= 0 || uaString.indexOf('trident') >= 0,
    Win32: win32(),
    GPU: PerformanceUtil.checkGPU().renderer,
    WebGL_version: PerformanceUtil.checkGPU().gl_version,
    GLSL_version: PerformanceUtil.checkGPU().gl_sl_version,
    MaxTextureSize: parseInt(PerformanceUtil.checkGPU().max_texture_size),
  };

  /**
   * 動作環境のパフォーマンスをチェックして点数などを返す : 戻り値 { score:string, msg:string, status:string }
   *
   * @param time
   */
  export function performanceCheck(time: number): { [key: string]: string } {
    const result: { [key: string]: string } = {};
    let totalScore: number = 100;
    let msg: string = '';
    const browser: string = ua.Browser;
    const gpu: string = ua.GPU;
    const gl: string = ua.WebGL_version;
    const glsl: string = ua.GLSL_version;
    const maxTex: number = ua.MaxTextureSize;
    let win32: string;
    let CPUSpeedScore: number = 100;
    let browserScore: number = 100;
    let GPUScore: number = 100;
    let WebGLScore: number = 100;

    // スコア計算
    // 32ビット判定
    /* if (ua.Win32) {
      totalScore -= 50;
      win32 = '(win32)';
    } else {
      win32 = '';
    } */

    // 素数判定計算を10000回行って取得した計算時間からCPU速度判定
    if (ua.Mobile || ua.Tablet) {
      if (time > 1500) {
        if (time < 2000) {
          CPUSpeedScore -= 5;
          totalScore -= 5;
        } else if (time < 2500) {
          CPUSpeedScore -= 20;
          totalScore -= 20;
        } else if (time < 3000) {
          CPUSpeedScore -= 45;
          totalScore -= 45;
        } else if (time < 3500) {
          CPUSpeedScore -= 60;
          totalScore -= 60;
        } else if (time < 4000) {
          CPUSpeedScore -= 85;
          totalScore -= 85;
        } else {
          CPUSpeedScore = 0;
          totalScore = 0;
        }
      }
    } else if (time > 750) {
      if (time < 1000) {
        CPUSpeedScore -= 5;
        totalScore -= 5;
      } else if (time < 1250) {
        CPUSpeedScore -= 20;
        totalScore -= 20;
      } else if (time < 1500) {
        CPUSpeedScore -= 45;
        totalScore -= 45;
      } else if (time < 1750) {
        CPUSpeedScore -= 60;
        totalScore -= 60;
      } else if (time < 2000) {
        CPUSpeedScore -= 85;
        totalScore -= 85;
      } else {
        CPUSpeedScore = 0;
        totalScore = 0;
      }
    }

    // ブラウザ判定
    if (browser !== 'Chrome') {
      totalScore -= 10;
      browserScore -= 10;
    }
    if (browser === 'Edge' || browser === 'Safari') {
      totalScore -= 5;
      browserScore -= 5;
    }
    if (browser === 'Opera') {
      totalScore -= 10;
      browserScore -= 10;
    }
    if (browser === 'Internet Explorer') {
      totalScore -= 20;
      browserScore -= 20;
    }
    if (browser === 'unknown' || browser === 'Firefox') {
      totalScore = 0;
      browserScore = 0;
    }

    // GPUの機種判定
    if (!gpu) {
      totalScore = 0;
      GPUScore = 0;
    }
    if (gpu.match(/NVIDIA/)) {
      if (!gpu.match(/(?=.*GeForce)(?=.*GTX)/)) {
        totalScore -= 5;
        GPUScore -= 5;
        if (gpu.match(/GT/)) {
          totalScore -= 20;
          GPUScore -= 20;
        }
      }
    } else if (gpu.match(/AMD/)) {
      if (!gpu.match(/(?=.*Radeon)(?=.*R)/)) {
        totalScore -= 5;
        GPUScore -= 5;
        if (gpu.match(/HD/)) {
          totalScore -= 20;
          GPUScore -= 20;
        }
      }
    } else if (gpu.match(/(?=.*Apple)(?=.*A)/)) {
      if (gpu.match(/5/) || gpu.match(/6/) || gpu.match(/7/) || gpu.match(/8/)) {
        totalScore -= 25;
        GPUScore -= 25;
      } else {
        totalScore -= 20;
        GPUScore -= 20;
      }
    } else {
      totalScore -= 10;
      GPUScore -= 10;
      if (gpu.match(/(?=.*Intel)(?=.*HD)(?=.*Graphics)/)) {
        totalScore -= 35;
        GPUScore -= 35;
      }
    }

    // アプリケーションが動作している環境のWebGLで使用できる最大テクスチャサイズで判定
    if (maxTex < 16384) {
      if (maxTex >= 16384 * 0.5) {
        totalScore -= 10;
        WebGLScore -= 10;
      } else if (maxTex >= 4096) {
        totalScore -= 20;
        WebGLScore -= 20;
      } else if (maxTex >= 1024) {
        totalScore -= 50;
        WebGLScore -= 50;
      } else {
        totalScore = 0;
        WebGLScore = 0;
      }
    }

    // スコアが0以下になっていたら0にする
    if (totalScore < 0) {
      totalScore = 0;
    }
    const minTotalScore = Math.min(CPUSpeedScore, browserScore, GPUScore, WebGLScore);
    result.totalScore = minTotalScore.toString();
    result.CPUSpeedScore = CPUSpeedScore.toString();
    result.browserScore = browserScore.toString();
    result.GPUScore = GPUScore.toString();
    result.WebGLScore = WebGLScore.toString();

    // 算出したスコアから動作快適度を決定
    if (minTotalScore >= 100) {
      msg = 'この環境では快適に動作します。';
    } else if (minTotalScore >= 75) {
      msg = 'この環境ではほぼ問題なく動作します。';
    } else if (minTotalScore >= 50) {
      msg = 'この環境では動作しますが遅延などが発生する可能性があります。';
    } else {
      msg = 'この環境では動作しないか動作保証はできません。';
    }
    result.msg = msg;

    // GPU ステータス
    result.status = `<p>[Browser] ${browser}${win32
    }</p><p>[GPU] ${gpu
    }</p><p>[WebGL] ${gl
    }</p><p>[GLSL] ${glsl
    }</p><p>[Max Texture Size] ${maxTex}</p>`;
    //
    return result;
  }

}
